import React from 'react'
import { withLocalize } from 'react-localize-redux'

import { store } from '../../helpers'
import { LoginModal } from '../../components/Modals/LoginModal'
import { confirmationServices } from '../../services'
import { alertActions } from '../../actions'
import { Spinner } from '../../components/Spinner'

class Confirmation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      confirmed: false,
      loading: true,
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.handleResendConfirmation = this.handleResendConfirmation.bind(this)
  }

  componentDidMount() {
    const { token } = this.props.match.params
    const { dispatch } = store

    confirmationServices.create(token).then(
      response => {
        this.setState({
          confirmed: true,
          loading: false,
        })
      },
      error => {
        if (error.response) {
          const errors = error.response.data.errors
          if (errors) {
            errors.forEach(e => {
              dispatch(alert.error(e))
            })
          }
        }

        this.setState({
          loading: false,
        })
      }
    )
  }

  handleResendConfirmation(event) {
    const { dispatch } = store
    const { token } = this.props.match.params
    const { translate } = this.props

    confirmationServices.update(token).then(
      response => {
        dispatch(alertActions.success(translate('alert.emailSent')))
      },
      error => {
        if (error.response) {
          const errors = error.response.data.errors
          if (errors) {
            errors.forEach(e => {
              dispatch(alertActions.error(e))
            })
          }
        }
      }
    )
  }

  toggleModal() {
    const { showModal } = this.state

    this.setState({
      showModal: !showModal,
    })
  }

  render() {
    const { showModal, confirmed, loading } = this.state
    const { translate } = this.props

    return (
      <div>
        <LoginModal showModal={showModal} onClose={() => this.toggleModal()} />
        <div className="container mt-4 mb-4">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="heading">
                {translate('confirmation.header.account')}{' '}
                <span className="text-primary">
                  {translate('confirmation.header.confirmation')}
                </span>
              </h2>
              {loading ? (
                <div className="text-center">
                  <Spinner loading={loading} />
                </div>
              ) : confirmed ? (
                <p className="lead">
                  {translate('confirmation.confirmed.message')}
                  <span className="btn-custom" onClick={this.toggleModal}>
                    {translate('confirmation.confirmed.link')}
                  </span>
                </p>
              ) : (
                <div>
                  <p className="lead">
                    {translate('confirmation.unconfirmed.message')}
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={this.handleResendConfirmation}
                  >
                    {translate('confirmation.unconfirmed.link')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withLocalize(Confirmation)
